<article class="formEditor">
    <span class="formLabel">{{ labelText() }}</span>

    <lib-generic-type-ahead-dropdown
        [source]="items()"
        [selectedItem]="selectedItem()"
        (selectedItemChange)="onSelectedItemChange($event)"
        [config]="{
            defaultText: placeholderText(),
            itemDisplayKey: 'name'
        }"
        [placeholder]="placeholderText()"
        (textChange)="onEntityTextChange($event)"
        [isReadOnly]="isReadOnly()"
        id="countries"
    >
    </lib-generic-type-ahead-dropdown>
</article>
